export function validarEmail(valor) {
  valor = valor.replace(/\s/g, "_");
  return (/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,3})$/i.test(valor));
}

export function sinEspacios(valor) {
  valor = valor.replace(/\s/g, "");
  return valor;
}

export function validarCelular(valor) {
  const expresion = /^[0-9]{9}$/;
  return !(isNaN(valor) || !expresion.test(valor));
}

export function calle(txtComp, txtCalle) {
  let valor;
  if (txtComp === txtCalle) {
    valor = false;
  } else {
    if (txtComp !== txtCalle) {
      valor = true;
    }
  }
  return valor;
}

export function numero(txtComp, txtNumero) {
  let valor;
  if (txtComp === txtNumero) {
    valor = false;
  } else {
    if (txtComp !== txtNumero) {
      valor = true;
    }
  }
  return valor;
}

export function resto(txtComp, txtResto) {
  let valor;
  if (txtComp === txtResto) {
    valor = false;
  } else {
    if (txtComp !== txtResto) {
      valor = true;
    }
  }
  return valor;
}

export function region(txtComp, codRegion) {
  let valor;
  if (txtComp === codRegion) {
    valor = false;
  } else {
    if (txtComp !== codRegion) {
      valor = true;
    }
  }
  return valor;
}

export function comuna(txtComp, codComuna) {
  let valor;
  if (txtComp === codComuna) {
    valor = false;
  } else {
    if (txtComp !== codComuna) {
      valor = true;
    }
  }
  return valor;
}

// Convierte una cadena Base64 a ArrayBuffer
export function base64ToArrayBuffer(base64) {
  const binaryString = atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

// Convierte un ArrayBuffer a Base64
export function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}